export const sampleCartProducts = [
  {
    id: 'nora-cardigan',
    sku: '20-ECRU-KNITWEAR',
    price: 99,
    price_currency: 'EUR',
    quantity: 1,
    product: { name: 'Nora Cardigan - Ecru' },
  },
  {
    id: 'grace-barrel-leg-jean',
    sku: '10MID-WASH BLUE-SHORT',
    price: 45,
    price_currency: 'EUR',
    quantity: 1,
    product: { name: 'Grace Barrel Leg Jean - Mid Wash Blue' },
  },
]
